import { getApiErrorMessage } from "@/helpers/get-api-error-message";
import { toast } from "@/hooks/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createInvite } from "../services/create-invite";

export default function useInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createInvite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invites"] });
      toast({
        title: "Invite sent successfully",
      });
    },
    onError: (err) => {
      console.error(err);
      toast({
        title: "Failed to send invite",
        description: getApiErrorMessage(err, "Failed to send invite"),
        variant: "destructive",
      });
    },
  });
}
